import { useState } from "react";
import { UserCheck } from "lucide-react";
import { http, formatApiError } from "../../lib/api";

// Visiteurs annoncés aujourd'hui : arrivée en un clic (badge facultatif)
export function ExpectedToday({ items, keys, onDone }) {
  const [badge, setBadge] = useState({});
  const [err, setErr] = useState("");
  if (!items.length) return null;
  const arrive = async (x) => {
    setErr("");
    try {
      await http.post("/agent-app/visitors", { site_id: x.site_id, name: x.name, company: x.company, host: x.host, purpose: x.purpose, plate: x.plate,
        badge_key_id: badge[x.id] || null, expected_id: x.id });
      onDone();
    } catch (e) { setErr(formatApiError(e)); }
  };
  return (
    <section data-testid="expected-today">
      <h2 className="font-display text-lg font-extrabold mb-2">Attendus aujourd&apos;hui <span className="text-sm text-slate-500">({items.length})</span></h2>
      {err && <div className="text-sm text-rose-700 mb-2">{err}</div>}
      <div className="bg-white border border-slate-200 rounded-xl divide-y divide-slate-100">
        {items.map((x) => {
          const badges = keys.filter((k) => k.site_id === x.site_id && k.kind === "badge" && !k.loan);
          return (
            <div key={x.id} className="px-4 py-3 space-y-2" data-testid={`expected-today-${x.id}`}>
              <div className="flex items-center gap-3">
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-sm truncate">{x.name}{x.company && <span className="font-normal text-slate-500"> · {x.company}</span>}</div>
                  <div className="text-xs text-slate-500 truncate">{x.time_from || x.time_to ? `${x.time_from || "…"} – ${x.time_to || "…"}` : "Toute la journée"}{x.host && ` · ${x.host}`}{x.purpose && ` · ${x.purpose}`}</div>
                </div>
                <button data-testid={`expected-arrive-${x.id}`} onClick={() => arrive(x)} className="inline-flex items-center gap-1 text-sm font-bold rounded-lg px-3 py-2 bg-[#0B2A7A] text-white"><UserCheck className="h-4 w-4" />Arrivée</button>
              </div>
              {badges.length > 0 && (
                <select data-testid={`expected-badge-${x.id}`} value={badge[x.id] || ""} onChange={(e) => setBadge({ ...badge, [x.id]: e.target.value })} className="w-full border border-slate-300 rounded-lg px-2 py-1.5 text-xs bg-white">
                  <option value="">Aucun badge remis</option>
                  {badges.map((k) => <option key={k.id} value={k.id}>Badge : {k.label}</option>)}
                </select>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
